module.exports = __webpack_public_path__ + "img/difficultyLevel_3_gray.db4debb0.svg";